import Blue from "~/core";
import autoComplete from "@tarekraafat/autocomplete.js";

new Blue({
  name: "Submit Search",
  selector: ".header__search",
  setup(form) {
    const redirect = form.dataset.redirect;
    const input = form.querySelector('.searchField__input');
    const submit = form.querySelector('.header__search-submit');
    
    const submitSearch = () => { 
      window.location.href = `${redirect}?q=${input.value}`;

      if(window.location.href.includes(redirect)){
        window.location.reload()
      }
      
     }

    this.$addEvents(form, 'submit.prevent', submitSearch);
    this.$addEvents(input, 'enter.prevent', submitSearch);
    this.$addEvents(submit, 'click.prevent enter.prevent', submitSearch);
  }
});


new Blue({
  name: "Header Search",
  selector: ".header__search",
  setup(search) {
    const header = document.querySelector(".header");
    const searchToggle = header.querySelector(".header__nav-search");
    const searchClose = header.querySelector(".header__search-close");
    const nav = header.querySelector(".header__nav");

    this.$addEvents(
      [searchToggle, searchClose],
      "click.prevent enter.prevent",
      () => {
        document.body.classList.toggle("is-locked");
        search.classList.toggle("is-open");
        header.classList.remove("is-open");
        [...nav.querySelectorAll(".is-open")].forEach(i =>
          i.classList.remove("is-open")
        );
      }
    );

    this.$screen.lg.addListener(e => {
      search.classList.remove("is-open");
    });
  }
});

function initAutocomplete(searchBox) {
  searchBox.addEventListener("keydown", function(e) {
    if (e.key === "Enter") {
      if (searchBox.value.length >= 3) {
        history.pushState("", "", `/search-results#/?q=${searchBox.value}`)
        location.reload();
      } else {
                e.preventDefault();
            }
    }
  });

  if (searchBox) {
    const autoCompleteJS = new autoComplete({
      selector: "#" + searchBox.id,
      name: searchBox.id,
      data: {
        src: async () => {
          let query = {
            searchTerm: searchBox.value
          };

          const url = "/api/search/suggest";
          
          const response = await fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json"
            },
            redirect: "follow",
            referrerPolicy: "no-referrer",
            body: JSON.stringify(query)
          });
          const result = await response.json();
          return result;
        },
        key: ["title"],
        results: list => {
          return list;
        }
      },
      debounce: 300,
      threshold: 3,
      trigger: {
        event: ["input", "focus"]
      },
      placeHolder: "Search",
      searchEngine: (query, record) => {
        return record;
      },
      highlight: true,
      maxResults: 10,
      resultItem: {
        content: (data, element) => {
          // Modify Results Item Style
          //element.style = "display: flex; justify-content: space-between;";
          // Modify Results Item Content
          //element = document.createElement('div');
          element.innerHTML = `<blue-component observe="observe" size="LG" on-screen="true" visible-ratio="1.00">
          <span slot="content"><div class="card card--horizontal">
              <div class="card__content"><a href="${data.value.url}" aria-label="${data.value.title}">
                  <h2 class="card__heading"><span>${data.value.title}</span></h2></a>
                <p class="card__copy">${data.value.summary}</p>
              </div>
            </div></span></blue-component>`;
        }
      },
      noResults: false,
      onSelection: feedback => {
        searchBox.blur();
        // Prepare User's Selected Value
        const selection = feedback.selection.value[feedback.selection.key];
        // Render selected choice to selection div
        document.querySelector(".selection").innerHTML = selection;
        // Replace Input value with the selected value
        searchBox.value = selection;
        // Console log autoComplete data feedback
      }
    });
  }
}

new Blue({
  name: "Autocomplete Search",
  selector: ".searchField__input",
  setup(searchBox) {
        if (this.$browser.name !== 'ie') {
            initAutocomplete(searchBox);
        }
  }
});

new Blue({
  name: "Autocomplete Search Page",
  selector: "#no-page-search-box",
  setup(searchBox) {
        if (this.$browser.name !== 'ie') {
            initAutocomplete(searchBox);
        }
  }
});